import { isArray } from 'lodash-es'

import { getApiVersion, http } from '../utils/domain'

import {
  buildQueries,
  parseFormDefs,
  transformFields,
  transformerBatchEditData,
} from '../utils/transformers'

const prefix = (appId, tbId) => {
  return `${getApiVersion()}/apps/${appId}/tbs/${tbId}`
}

function getTbTagsMap(tag) {
  if (tag === 'STANDARD') return 'standard'
  if (tag === 'AREA') return 'area'
  if (tag === 'PUNCHIN') return 'punchIn'
  if (tag === 'TABLELOG') return 'tableLog'
  if (tag === 'FOOTPRINTER') return 'footPrinter'
  if (tag === 'VIDEO') return 'video'
  if (tag === 'STANDARDSPLIT') return 'caseStandardSplit'

  return tag
}

// 获取app的所有表单, 可选的获取表单定义
export const fetchTbsDef = (appId, isFetchDef = true) => {
  return http()
    .get(`${getApiVersion()}/apps/${appId}/tbs?def=${isFetchDef}`)
    .json()
    .then((res) => {
      const tbs = {}
      res.forEach((x) => {
        const tbNameId = getTbTagsMap(x.tag)
        tbs[x.tbId] = {
          tbId: x.tbId,
          tbSlug: x.tbSlug,
          appId,
          enableStandardBind: x.enableStandardBind,
          idFieldName: x.idFieldSlug,
          tbName: x.tbName,
          tbNameId: tbNameId === 'GENERAL' ? x.tbId : tbNameId,
          fields: parseFormDefs(x.def),
          extend: x.extend || {},
        }

        if (tbNameId !== 'GENERAL') {
          tbs[tbNameId] = tbs[x.tbId]
        }
      })
      return tbs
    })
}

/**
 * 获取表单数据
 * @param {*} appId
 * @param {*} tbId
 * @param {*} viewConfig
 * @param {*} params
 * @returns
 */
export const fetchTableData = (
  appId,
  tbId,
  viewConfig,
  params,
  realCount = true,
  useAuth = true
) => {
  // console.log(`${prefix(appId, tbId)}/data`, {
  //   ...buildQueries(viewConfig),
  //   ...params,
  // })
  return http()
    .post(
      `${prefix(appId, tbId)}/data?realCount=${realCount}&useAuth=${useAuth}`,
      {
        ...buildQueries(viewConfig),
        ...params,
      }
    )
    .json()
    .then((res) => {
      return {
        tbData: res.content,
        pageNum: res.pageNumber,
        total: res.totalElements,
        totalPages: res.totalPages,
        pageSize: res.size,
      }
    })
}

export const fetchTableDataEnhance = (appId, tbId, viewConfig, params) => {
  return http()
    .post(`${prefix(appId, tbId)}/data_enhance`, {
      ...buildQueries(viewConfig),
      ...params,
    })
    .json()
    .then((res) => {
      return {
        tbData: res.content,
        pageNum: res.pageNumber,
        total: res.totalElements,
        pageSize: res.size,
      }
    })
}

export const fetchTableDataCount = (appId, tbId, viewConfig, params) => {
  return http()
    .post(`${prefix(appId, tbId)}/dataCount?realCount=true`, {
      ...buildQueries(viewConfig),
      ...params,
    })
    .json()
    .then((count) => {
      return count
    })
}

// 直接使用后端定义的查询语句查询数据
// 该接口用于后端返回给前端查询语句,能使用前端查询语法就继续用 fetchTableData
/**
 * 直接使用后端定义的查询语句查询数据
 * 该接口用于后端返回给前端查询语句,能使用前端查询语法就继续用 fetchTableData
 * @param {*} appId
 * @param {*} tbId
 * @param {*} queryBody
 * @returns
 */
export const queryFetchTableData = (appId, tbId, queryBody) => {
  return http()
    .post(`${prefix(appId, tbId)}/data`, queryBody)
    .json()
    .then((res) => {
      return {
        tbData: res.content,
        pageNum: res.pageNumber,
        total: res.totalElements,
        pageSize: res.size,
      }
    })
}

/**
 * 更新表单
 * @param {*} appId
 * @param {*} tbId
 * @param {*} data
 * @returns
 */
export const updateFormFields = (appId, tbId, data) => {
  const transFields = transformFields(data.fields)
  return http()
    .put(`${getApiVersion()}/apps/${appId}/tbs/${tbId}/def`, {
      tbNodes: transFields,
    })
    .json()
}

/**
 * 新建表单
 * @param {*} appId
 * @param {*} tbName
 * @param {*} data
 * @returns
 */
export const createTb = (appId, tbName, data) => {
  const transFields = transformFields(data.fields)
  return http()
    .post(`${getApiVersion()}/apps/${appId}/tbs`, {
      tbName,
      tbNodes: transFields,
    })
    .json()
    .then((res) => {
      return (res && res.data) || {}
    })
}

/**
 * 新建数据
 * @param {*} appId
 * @param {*} tbId
 * @param {*} data
 * @returns
 */
export const createTbData = (appId, tbId, data) => {
  if (isArray(data)) {
    return http()
      .post(`${getApiVersion()}/apps/${appId}/tbs/${tbId}`, data[0], {
        throwHttpErrors: false,
      })
      .json()
      .then((res) => {
        return (res && res.data) || {}
      })
  }
  return http()
    .post(`${getApiVersion()}/apps/${appId}/tbs/${tbId}`, data, {
      throwHttpErrors: false,
    })
    .json()
    .then((res) => {
      return (res && res.data) || {}
    })
}

/**
 * 更新数据
 * @param {*} appId
 * @param {*} tbId
 * @param {*} data
 * @returns
 */
export const updateTbData = (appId, tbId, data) => {
  return http()
    .put(
      `${getApiVersion()}/apps/${appId}/tbs/${tbId}/data/${data.objectId}`,
      data,
      {
        throwHttpErrors: true,
      }
    )
    .json()
    .then((res) => {
      return (res && { ...res, objectId: data.objectId }) || {}
    })
}

/**
 * 批量删除数据
 * @param {*} appId
 * @param {*} tbId
 * @param {*} objectIds
 * @returns
 */
export const batchDestroyTbData = (appId, tbId, objectIds) => {
  return http()
    .delete(
      `${getApiVersion()}/apps/${appId}/tbs/${tbId}/data/batch`,
      objectIds
    )
    .json()
}

/**
 * 批量更新数据
 * @param {*} appId
 * @param {*} tbId
 * @param {*} data
 * @returns
 */
export const batchUpdateTbData = (appId, tbId, data) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tables/${tbId}/batchUpdateCollectionDataWithWrapper?useSlug=true&mapRes=true`,
      transformerBatchEditData(data)
    )
    .json()
    .then((res) => {
      return (res || []).map((v) => {
        return { objectId: v.objectId, ...v.slugMap }
      })
    })
}

/**
 * 清缓存
 * @returns
 */
export const justDeleteTbDefCache = () => {
  return http().get(`${getApiVersion()}/super/tableData/justDeleteTbDefCache`)
}

/**
 * 获取数组类型的统计数据
 * @param {*} appId
 * @param {*} tbId
 * @param {*} slugs
 * @param {*} dsl
 * @returns
 */
export const fetchCountGroupBy = (
  appId,
  tbId,
  slug,
  viewConfig,
  enableAuthority = true
) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tbs/${tbId}/countDocumentByQueryDslAndGroupBy?slugs=${slug}&enableAuthority=${enableAuthority}`,
      {
        ...buildQueries(viewConfig),
      }
    )
    .json()
    .then((res) => {
      return res
    })
}

export const fetchCountDocumentByGroupBySlugs = (
  appId,
  tbId,
  slug,
  viewConfig
) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tbs/${tbId}/countDocumentByGroupBySlugs?slugs=${slug}`,
      {
        ...buildQueries(viewConfig),
      }
    )
    .json()
    .then((res) => {
      return res
    })
}

export const fetchCountIndexOfElement = (
  appId,
  tbId,
  slug,
  viewConfig,
  index
) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tbs/${tbId}/countDocumentByQueryDslAndIndexOfElement?tbId=${tbId}&slugs=${slug}&index=${index}`,
      {
        ...buildQueries(viewConfig),
      }
    )
    .json()
    .then((res) => {
      return res
    })
}
// 查询自己在某张表下绑定的objectId
export const fetchObjectIdsAtTable = (appId, tbId, targetTbId) => {
  return http()
    .get(
      `${getApiVersion()}/apps/${appId}/dataUserBindingRule/${targetTbId}/my?sourceTbId=${tbId}`
    )
    .json()
}

// 标记数据是否已读（针对组织）
// 表定义中有readOrg字段, 是组织的数组, 请求此接口会将用户的组织添加进去, 代表已读
export const tbDataMarkRead = (appId, tbId, objectId) => {
  return http()
    .put(`${getApiVersion()}/apps/${appId}/tbs/${tbId}/markRead/${objectId}`)
    .json()
}

// 导出生成问题通知单
export const exportNoticeFile = (tableDataId) => {
  const dsl = tableDataId
    ? {
        filters: {
          queries: [
            {
              queryTypes: ['equal'],
              queryType: 'equal',
              slug: 'tableDataId',
              value: tableDataId,
            },
          ],
        },
      }
    : {}
  return http()
    .post(`${getApiVersion()}/apps/fengtai`, {
      ...buildQueries(dsl),
    })
    .json()
    .then((res) => {
      return res
    })
}

// 流程-获取数据回显以及下拉可选数据
export const fetchUcaseExtBackFill = (
  appId,
  tbId,
  objectId,
  stageId,
  nodeUuid
) => {
  return http()
    .get(
      `${getApiVersion()}/apps/${appId}/ucase_ext/backFill?stageId=${stageId}&tbId=${tbId}&objectId=${objectId}&nodeUuid=${nodeUuid}`
    )
    .json()
}

// 批量创建/修改表单数据
export const batchUpsertCollectionData = (appId, tbId, formData) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tbs/${tbId}/batchUpsertCollectionData`,
      formData
    )
    .json()
}
